var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('ProjectZoneTimeChart',{attrs:{"height":280,"chartData":_vm.chartData,"options":_vm.options}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }